/**
 * @import { Place } from '@/features/world-map/types/place'
 */

import { Popup } from '@/ui/popup';
import { useEffect } from 'react';
import classes from './place-info.module.css';

/**
 * @param {object} props
 * @param {Place} props.place
 * @param {google.maps.marker.AdvancedMarkerElement} props.anchor
 * @param {() => void} [props.onClose]
 * @returns {React.JSX.Element | undefined}
 */
export function PlaceInfo({ place, anchor, onClose }) {
  const name = place.name;

  // Close automatically on map click
  useEffect(() => {
    const listener = anchor.map?.addListener('click', () => {
      onClose?.();
    });
    return () => {
      listener?.remove();
    };
  }, [anchor.map, onClose]);

  // Close automatically on bounds change
  useEffect(() => {
    // Delays listening to bounds changed to accommodate the mobile drawer's potential for map bounds to change as a
    // result of layout shift due to the cruise header's dynamic text, dynamic height, and the constrained width.
    const controller = new AbortController();
    const timeoutId = setTimeout(() => {
      const listener = anchor.map?.addListener('bounds_changed', () => {
        onClose?.();
      });
      controller.signal.addEventListener('abort', () => {
        listener?.remove();
      });
    }, 200);

    return () => {
      clearTimeout(timeoutId);
      controller.abort();
    };
  }, [anchor.map, onClose]);

  return name ? (
    <Popup className={classes.content} anchor={anchor} ariaLabel={name}>
      {name}
    </Popup>
  ) : undefined;
}
